import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useIntersection } from 'react-use';
import useIsBrowser from 'hooks/useIsBrowser';
import ModularProductCard from './ModularProductCard';
const ModularTopNavItems = t0 => {
  const $ = _c(11);
  const {
    isNavFixed: t1,
    collectionData,
    collectionInView,
    onTopNavClick
  } = t0;
  const isNavFixed = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== collectionData || $[1] !== collectionInView || $[2] !== isNavFixed || $[3] !== onTopNavClick) {
    let t3;
    if ($[5] !== collectionInView || $[6] !== isNavFixed || $[7] !== onTopNavClick) {
      t3 = collection => <ModularProductCard key={collection.name} className={cx({
        "![border-bottom:2px_solid_#107c8c]": isNavFixed && collectionInView === collection.id
      })} product={{
        ...collection.products[0],
        options: collection.options,
        collection: collection.name
      }} displayType="collection" onClick={() => {
        if (onTopNavClick) {
          onTopNavClick(collection.id);
        }
      }} isFixed={isNavFixed} collectionInView={collectionInView} thumbnail={collection.thumbnail} />;
      $[5] = collectionInView;
      $[6] = isNavFixed;
      $[7] = onTopNavClick;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = collectionData.map(t3);
    $[0] = collectionData;
    $[1] = collectionInView;
    $[2] = isNavFixed;
    $[3] = onTopNavClick;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <>{t2}</>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
const ModularTopNav = t0 => {
  const $ = _c(20);
  const {
    collectionData: t1,
    onTopNavClick: t2,
    collectionInView: t3
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const collectionData = t4;
  const onTopNavClick = t2 === undefined ? null : t2;
  const collectionInView = t3 === undefined ? 0 : t3;
  const navRef = useRef(null);
  const isBrowser = useIsBrowser();
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      threshold: 0.3
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const intersection = useIntersection(navRef, t5);
  const isStaticNavVisible = intersection ? intersection.isIntersecting : true;
  const isNavFixed = isBrowser && !isStaticNavVisible;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = element => {
      navRef.current = element;
    };
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== collectionData || $[5] !== collectionInView || $[6] !== onTopNavClick) {
    t7 = <div ref={t6} className="bg-white w-full max-[767px]:p-5 pt-12"><div className="grid grid-cols-[repeat(auto-fit,minmax(130px,48%)_)] gap-[10px] md:flex md:flex-wrap md:items-center md:justify-center"><ModularTopNavItems collectionData={collectionData} collectionInView={collectionInView} onTopNavClick={onTopNavClick} /></div></div>;
    $[4] = collectionData;
    $[5] = collectionInView;
    $[6] = onTopNavClick;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== isNavFixed) {
    t8 = cx("bg-white w-full h-[54px] left-0 opacity-0 pointer-events-none fixed top-0 transition-[opacity_.2s_ease-out] z-[5000] max-[767px]:p-0", {
      "opacity-100 pointer-events-auto transition-[opacity_.2s_ease-in]": isNavFixed
    });
    $[8] = isNavFixed;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== collectionData || $[11] !== collectionInView || $[12] !== onTopNavClick) {
    t9 = <div className="md:items-center md:justify-center bg-white [border-bottom:1px_solid_#e5e5e5] flex flex-row flex-nowrap w-full max-[767px]:overflow-x-auto"><ModularTopNavItems isNavFixed={true} collectionData={collectionData} collectionInView={collectionInView} onTopNavClick={onTopNavClick} /></div>;
    $[10] = collectionData;
    $[11] = collectionInView;
    $[12] = onTopNavClick;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8 || $[15] !== t9) {
    t10 = <div className={t8}>{t9}</div>;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t7) {
    t11 = <>{t7}{t10}</>;
    $[17] = t10;
    $[18] = t7;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
};
ModularTopNavItems.propTypes = {
  collectionData: PropTypes.array,
  onTopNavClick: PropTypes.func,
  collectionInView: PropTypes.number,
  isNavFixed: PropTypes.bool
};
ModularTopNav.propTypes = {
  collectionData: PropTypes.array,
  onTopNavClick: PropTypes.func,
  collectionInView: PropTypes.number
};
export default ModularTopNav;